// Iter 650 — Refresh otomatis ringan (Operator Bordir & Shella): cek sidik antrean tiap 10 dtk saat tab aktif,
//   langsung cek saat tab kembali aktif, muat ulang daftar HANYA bila berubah. Tidak pernah mengubah data.
import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { RefreshCw } from "lucide-react";
import { useAutoRefresh, isDirty, subscribeDirty } from "./use_auto_refresh";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function LiveQueueBar({ team, onOfflineChanged, events = {}, tid = "live-queue-bar" }) {
  const sig = useRef(null);
  const busyRef = useRef(false);
  const pendingOffline = useRef(false);
  const [at, setAt] = useState(null);
  const [err, setErr] = useState(false);
  const [busy, setBusy] = useState(false);
  const evRef = useRef(events);
  evRef.current = events;

  const applyOffline = useCallback(() => {
    if (isDirty()) { pendingOffline.current = true; return; }
    pendingOffline.current = false;
    Promise.resolve(onOfflineChanged?.()).catch(() => {});
  }, [onOfflineChanged]);
  useEffect(() => subscribeDirty((n) => { if (!n && pendingOffline.current) applyOffline(); }), [applyOffline]);

  const fire = (k) => evRef.current[k] && window.dispatchEvent(new Event(evRef.current[k]));
  const check = useCallback(async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    try {
      const r = await axios.get(`${API}/live/queue-signature`, { params: { team }, withCredentials: true, timeout: 8000 });
      const prev = sig.current;
      sig.current = r.data;
      if (prev) {
        if (prev.offline !== r.data.offline) applyOffline();
        if (prev.shopee !== r.data.shopee) fire("shopee");
        if (prev.tasks !== r.data.tasks) fire("tasks");
      }
      setAt(new Date()); setErr(false);
    } catch { setErr(true); }
    finally { busyRef.current = false; }
  }, [team, applyOffline]);

  useEffect(() => { check(); }, [check]);
  useEffect(() => {
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("online", check);
    return () => { document.removeEventListener("visibilitychange", onVis); window.removeEventListener("online", check); };
  }, [check]);
  useAutoRefresh({ enabled: true, intervalMs: 10_000, onRefresh: check, pauseWhenDirty: false });

  const manual = async () => {
    setBusy(true);
    try {
      fire("shopee"); fire("tasks");
      pendingOffline.current = false;
      await Promise.resolve(onOfflineChanged?.());
      sig.current = null; await check();
    } finally { setBusy(false); }
  };

  return <div className="press-live" data-testid={tid}>
    <span className="press-live-dot" aria-hidden="true" style={err ? { background: "#f59e0b" } : undefined}/>
    <span data-testid={`${tid}-updated`}>{err ? "Koneksi bermasalah — mencoba lagi otomatis" : at ? `Otomatis · diperbarui ${at.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}` : "Memeriksa…"}</span>
    <button type="button" onClick={manual} disabled={busy} data-testid={`${tid}-refresh`}><RefreshCw size={13} className={busy ? "spin" : ""}/> Muat Ulang</button>
  </div>;
}
